// src/components/NotificationBell.jsx

import { Bell } from "lucide-react";
import { useNotifications } from "../Context/NotificationContext";

const NotificationBell = ({ togglePanel }) => {
    const { notifications, notificationCount } = useNotifications();
    const unread = notifications.filter((n) => n.unread).length;

    return (
        <button className="relative" onClick={togglePanel}>
            <Bell className="w-6 h-6 text-white-800" style={{ color: "white" }} />

            {notificationCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs px-1.5 py-0.5 rounded-full">
                    {notificationCount}
                </span>
            )}
        </button>
    );
};

export default NotificationBell;
